module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/color/color.component.scss
// module id = ./src/app/productos/color/color.component.scss
// module chunks = main